import React from 'react';
import { brands } from '../mock';

const BrandLogos = () => {
  return (
    <section className="py-16 bg-[#0A0F0D] border-y border-[#22C55E]/10">
      <div className="max-w-7xl mx-auto px-6">
        <p className="text-center text-[#94A3B8] text-sm font-semibold mb-8 tracking-wide uppercase">
          Trusted by Leading Fitness Brands
        </p>
        <div className="flex flex-wrap justify-center items-center gap-12">
          {brands.map((brand, index) => (
            <div 
              key={index}
              className="text-[#94A3B8] text-2xl font-bold tracking-wider hover:text-[#22C55E] transition-all duration-300 cursor-pointer transform hover:scale-110 grayscale hover:grayscale-0"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {brand.logo}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandLogos;